import header from "./virtueller-rundgang.png";
import section1 from "./virtueller-rundgang.jpg";
import section2 from "./virtuellen-rundgang-erstellen.jpg";
import section3 from "./woman-sitting-on-couch.png";
import section4 from "./kamera-fuer-virtueller-rundgang.webp";

export { header, section1, section2, section3, section4 };
